import Vue from 'vue'

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'

Vue.use(BootstrapVue, {
  BModal: {
    cancelTitle: 'Nu',
    okTitle: 'Da',
    title: 'Confirmare',
    hideHeaderClose: true,
    centered: true
  }
})
Vue.use(BootstrapVueIcons)
